import AutoFilledIcon from './AutoFilledIcon';

export default AutoFilledIcon;
